/* do not edit. this file is generated by npm run lib:icons and constantly overwritten */
import React from 'react'
export const IconChevronBottomFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 16 16' {...props}>
    <path
      fill='currentColor'
      d='M7.444 10.169 4.232 6.946C3.737 6.45 4.087 5.6 4.788 5.6h6.424c.7 0 1.051.85.556 1.346L8.556 10.17a.784.784 0 0 1-1.112 0'
    />
  </svg>
)
